import Vue from 'vue'
import Vuex from 'vuex'
import login from "./modules/login"
import menuCollapse from './modules/menuCollapse'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    login,
    menuCollapse
  }
})
